import React, { memo, useCallback } from 'react';
import SearchList from 'containers/components/SearchList';
import { getLiteral } from 'utils/getLiteral';

import { LEADS_LITERALS } from './literals';

const PLACES_ENTITY = {
    entity: 'leadsPlaces',
    trueName: 'leadsPlaces',
};

const geocodePlace = (address) =>
    new Promise((resolve, reject) => {
        if (!window.google?.maps?.Geocoder) {
            reject();
            return;
        }

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            const location = results?.[0]?.geometry?.location;
            if (status !== window.google.maps.GeocoderStatus.OK || !location) {
                reject();
                return;
            }

            resolve({ lat: location.lat(), lng: location.lng() });
        });
    });

const PlaceSearch = ({ onSelectPlace }) => {
    const handleSearch = useCallback(
        (value) => {
            if (!value) return;

            geocodePlace(value)
                .then(onSelectPlace)
                .catch(() => {});
        },
        [onSelectPlace],
    );

    return (
        <SearchList
            entity={PLACES_ENTITY}
            list="places"
            field="place"
            placeholder={getLiteral(LEADS_LITERALS.placeSearchPlaceholder)}
            onLocalSearch={handleSearch}
            isClearable
            useAsSimpleSearch
            hideDropdownIndicator
        />
    );
};

export default memo(PlaceSearch);
